<div class="imageViewer">
  <div>
    <dx-gallery
      #gallery
      [width]="'200'"
      [height]="'200'"
      [(dataSource)]="internalDataSource"
      [(selectedIndex)]="internalSelectedIndex"
      [swipeEnabled]="true"
      [showIndicator]="true"
      [noDataText]=""
      (onItemClick)="itemClick($event)"
    >
    </dx-gallery>
    <div class="gallery-actions">
      @if (this.selectedMediaDocument?.downloadable) {
        <button
          mat-mini-fab
          type="button"
          (click)="downloadPreview()"
          [matTooltip]="this.res?.get('Preview_Tooltip')"
          class="downloadPreview"
        >
          <mat-icon [svgIcon]="this.res?.svgName('download-image')"></mat-icon>
        </button>
      }

      <ng-content select="[gallery-actions]"></ng-content>
    </div>
  </div>
</div>

<div #messageBoxContainer></div>
